// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"4cb3f459","85":"81c1ae7a","114":"f36dd587","347":"bbe23b49","348":"5d758e58","447":"abddf924","499":"7840295a","503":"ffb21c50","547":"a75f4351"}[chunkId] + ".chunk.js";
};